export default __webpack_public_path__ + "static/media/inventory-item-empty.3b280ec7.svg";